/**
 * Bor fajtája   * FERNAO_IS_RED - Fernao pires   * HER_CURLS - Fürtike   * WHITE_BAKATOR - Fehér bakator   * WHITE_BURGUNDY - Fehér burgundi   * FURMINT - Furmint   * SPICY_TRAMINI - Fűszeres tramini   * GROSS_PLAN - Gros plant   * GROS_SAUVIGNON - Gros Sauvignon   * GRUNER_VELTELINER - Grüner Velteliner   * HARSLEVELU_OF_DEBRO - Debrői Hárslevelű   * LIME_LEAVED - Hárslevelű   * OLIVER_IRSAI - Irsai olivér   * ISSAKI_GOLDEN_SARFEHER - Izsáki Arany Sárfehér   * ISAACS_MUD_WHITE - Izsáki sárfehér   * SHEEPS_TAIL - Juhfark   * ROUND_LEAVED - Kereklevelű   * KERNER - Kerner   * BLUE_COLLARED - Kéknyelű   * PRINCESS - Királyleányka   * FAT_GRAPES_WHITE_GRAPES - Kövérszőlő (Fehérszőlő)   * KOVIDINKA - Kövidinka   * KUNLEANY - Kunleány   * GIRL - Leányka   * MACABEO - Macabeo   * MARSANNE - Marsanne   * MALVASIA - Malvasia   * MUSCAT - Muskotály   * MUSCAT_OTTONEL - Muscat ottonel   * MULLER_THURGAU - Müller Thurgau   * MUSCAT_LUNEL - Muscat lunel   * ITALIAN_RIESLING - Olaszrizling   * OTTONEL_MUSCAT - Ottonel muskotály   * PINOT_BIANCO - Pinot bianco   * PINOT_BLANC - Pinot blanc   * PINOT_GRIS - Pinot gris   * PINOT_GRIGIO - Pinot grigio   * RED_SLIME - Piros szlanka   * RED_TRAMINI - Piros tramini   * RED_VELTELINI - Piros veltelini   * BRATISLAVA_WHITE - Pozsonyi fehér   * RHINE_RIESLING - Rajnai rizling   * RIESLINGSZYLVANI - Rizlingszilváni   * YELLOW_MUSCAT - Sárga muskotály   * SAUVIGNON_BLANC - Sauvignon blanc   * SAUVIGNON_BIANCO - Sauvignon bianco   * SEMILLON - Semillon   * GRAY_FRIENDLY - Szürkebarát   * TRAMINI - Tramini   * VIOGNIER - Viognier   * VULCAN - Vulcanus   * VALTELIN_BLANC - Valtelin blanc   * BARBERA - Barbera   * BULLS_BLOOD - Bikavér   * BLAUBURGER - Blauburger   * CABERNET_FRANC - Cabernet franc   * CABERNET_SAUVIGNON - Cabernet sauvignon   * CARMENERE - Carmenere   * CHIANTI - Chianti   * KISSING_GRAPE - Csókaszőlő   * BLACK_PAVEMENT - Fekete járdovány   * BLACK_GIRL - Feketeleányka   * GAMAY - Gamay   * GRENACHE - Grenache   * KADARKA - Kadarka   * BLUE_FRANKISH - Kékfrankos   * LAMBRUSCO - Lambrusco   * MALBEC - Malbec   * MAVRODAPHNE - Mavrodaphne   * MENCIA - Mencía   * MERLOT - Merlot   * MONTEPULCIANO - Montepulciano   * NEBBIOLO - Nebbiolo   * NERO_DAVOLA - Nero D\'avola   * PETIT_VERDOT - Petit Verdot   * PINOT_NOIR - Pinot noir   * PINOTAGE - Pinotage   * PORTO - Portói   * PORTUGUESE - Portugiser   * PRIMITIVE - Primitivo   * REFOSCO - Refosco   * ROSE_BLENDING_CUVEE - Rozé házasítás (cuvée)   * SANGIOVESE - Sangiovese   * ST_LAWRENCE - St. Laurent   * SYRAH - Syrah   * TEMPRANILLO - Tempranillo   * TURAN - Turán   * RED_BLEND_CUVEE - Vörös házasítás (cuvée)   * ZWEIGELT - Zweigelt   * BLEND_CUVEE - házasítás (cuvée)   * OTHER - egyéb
 */
export type TypeOfWine =
  | 'FERNAO_IS_RED'
  | 'HER_CURLS'
  | 'WHITE_BAKATOR'
  | 'WHITE_BURGUNDY'
  | 'FURMINT'
  | 'SPICY_TRAMINI'
  | 'GROSS_PLAN'
  | 'GROS_SAUVIGNON'
  | 'GRUNER_VELTELINER'
  | 'HARSLEVELU_OF_DEBRO'
  | 'LIME_LEAVED'
  | 'OLIVER_IRSAI'
  | 'ISSAKI_GOLDEN_SARFEHER'
  | 'ISAACS_MUD_WHITE'
  | 'SHEEPS_TAIL'
  | 'ROUND_LEAVED'
  | 'KERNER'
  | 'BLUE_COLLARED'
  | 'PRINCESS'
  | 'FAT_GRAPES_WHITE_GRAPES'
  | 'KOVIDINKA'
  | 'KUNLEANY'
  | 'GIRL'
  | 'MACABEO'
  | 'MARSANNE'
  | 'MALVASIA'
  | 'MUSCAT'
  | 'MUSCAT_OTTONEL'
  | 'MULLER_THURGAU'
  | 'MUSCAT_LUNEL'
  | 'ITALIAN_RIESLING'
  | 'OTTONEL_MUSCAT'
  | 'PINOT_BIANCO'
  | 'PINOT_BLANC'
  | 'PINOT_GRIS'
  | 'PINOT_GRIGIO'
  | 'RED_SLIME'
  | 'RED_TRAMINI'
  | 'RED_VELTELINI'
  | 'BRATISLAVA_WHITE'
  | 'RHINE_RIESLING'
  | 'RIESLINGSZYLVANI'
  | 'YELLOW_MUSCAT'
  | 'SAUVIGNON_BLANC'
  | 'SAUVIGNON_BIANCO'
  | 'SEMILLON'
  | 'GRAY_FRIENDLY'
  | 'TRAMINI'
  | 'VIOGNIER'
  | 'VULCAN'
  | 'VALTELIN_BLANC'
  | 'BARBERA'
  | 'BULLS_BLOOD'
  | 'BLAUBURGER'
  | 'CABERNET_FRANC'
  | 'CABERNET_SAUVIGNON'
  | 'CARMENERE'
  | 'CHIANTI'
  | 'KISSING_GRAPE'
  | 'BLACK_PAVEMENT'
  | 'BLACK_GIRL'
  | 'GAMAY'
  | 'GRENACHE'
  | 'KADARKA'
  | 'BLUE_FRANKISH'
  | 'LAMBRUSCO'
  | 'MALBEC'
  | 'MAVRODAPHNE'
  | 'MENCIA'
  | 'MERLOT'
  | 'MONTEPULCIANO'
  | 'NEBBIOLO'
  | 'NERO_DAVOLA'
  | 'PETIT_VERDOT'
  | 'PINOT_NOIR'
  | 'PINOTAGE'
  | 'PORTO'
  | 'PORTUGUESE'
  | 'PRIMITIVE'
  | 'REFOSCO'
  | 'ROSE_BLENDING_CUVEE'
  | 'SANGIOVESE'
  | 'ST_LAWRENCE'
  | 'SYRAH'
  | 'TEMPRANILLO'
  | 'TURAN'
  | 'RED_BLEND_CUVEE'
  | 'ZWEIGELT'
  | 'BLEND_CUVEE'
  | 'CHARDONNAY'
  | 'EZERJO'
  | 'SPICED_FROM_CSERSZEG'
  | 'BUDAI_ZOLD'
  | 'SZAMORODNI'
  | 'ZENGOE'
  | 'ZENITH'
  | 'CSABAGYONGYE'
  | 'CHENIN_BLANC'
  | 'CIRFANDLI'
  | 'ZETA'
  | 'ASZU'
  | 'ESSENCE_OF_ASZU'
  | 'OTHER';

export const TypeOfWine = {
  FernaoIsRed: 'FERNAO_IS_RED' as TypeOfWine,
  HerCurls: 'HER_CURLS' as TypeOfWine,
  WhiteBakator: 'WHITE_BAKATOR' as TypeOfWine,
  WhiteBurgundy: 'WHITE_BURGUNDY' as TypeOfWine,
  Furmint: 'FURMINT' as TypeOfWine,
  SpicyTramini: 'SPICY_TRAMINI' as TypeOfWine,
  GrossPlan: 'GROSS_PLAN' as TypeOfWine,
  GrosSauvignon: 'GROS_SAUVIGNON' as TypeOfWine,
  GrunerVelteliner: 'GRUNER_VELTELINER' as TypeOfWine,
  HarsleveluOfDebro: 'HARSLEVELU_OF_DEBRO' as TypeOfWine,
  LimeLeaved: 'LIME_LEAVED' as TypeOfWine,
  OliverIrsai: 'OLIVER_IRSAI' as TypeOfWine,
  IssakiGoldenSarfeher: 'ISSAKI_GOLDEN_SARFEHER' as TypeOfWine,
  IsaacsMudWhite: 'ISAACS_MUD_WHITE' as TypeOfWine,
  SheepsTail: 'SHEEPS_TAIL' as TypeOfWine,
  RoundLeaved: 'ROUND_LEAVED' as TypeOfWine,
  Kerner: 'KERNER' as TypeOfWine,
  BlueCollared: 'BLUE_COLLARED' as TypeOfWine,
  Princess: 'PRINCESS' as TypeOfWine,
  FatGrapesWhiteGrapes: 'FAT_GRAPES_WHITE_GRAPES' as TypeOfWine,
  Kovidinka: 'KOVIDINKA' as TypeOfWine,
  Kunleany: 'KUNLEANY' as TypeOfWine,
  Girl: 'GIRL' as TypeOfWine,
  Macabeo: 'MACABEO' as TypeOfWine,
  Marsanne: 'MARSANNE' as TypeOfWine,
  Malvasia: 'MALVASIA' as TypeOfWine,
  Muscat: 'MUSCAT' as TypeOfWine,
  MuscatOttonel: 'MUSCAT_OTTONEL' as TypeOfWine,
  MullerThurgau: 'MULLER_THURGAU' as TypeOfWine,
  MuscatLunel: 'MUSCAT_LUNEL' as TypeOfWine,
  ItalianRiesling: 'ITALIAN_RIESLING' as TypeOfWine,
  OttonelMuscat: 'OTTONEL_MUSCAT' as TypeOfWine,
  PinotBianco: 'PINOT_BIANCO' as TypeOfWine,
  PinotBlanc: 'PINOT_BLANC' as TypeOfWine,
  PinotGris: 'PINOT_GRIS' as TypeOfWine,
  PinotGrigio: 'PINOT_GRIGIO' as TypeOfWine,
  RedSlime: 'RED_SLIME' as TypeOfWine,
  RedTramini: 'RED_TRAMINI' as TypeOfWine,
  RedVeltelini: 'RED_VELTELINI' as TypeOfWine,
  BratislavaWhite: 'BRATISLAVA_WHITE' as TypeOfWine,
  RhineRiesling: 'RHINE_RIESLING' as TypeOfWine,
  Rieslingszylvani: 'RIESLINGSZYLVANI' as TypeOfWine,
  YellowMuscat: 'YELLOW_MUSCAT' as TypeOfWine,
  SauvignonBlanc: 'SAUVIGNON_BLANC' as TypeOfWine,
  SauvignonBianco: 'SAUVIGNON_BIANCO' as TypeOfWine,
  Semillon: 'SEMILLON' as TypeOfWine,
  GrayFriendly: 'GRAY_FRIENDLY' as TypeOfWine,
  Tramini: 'TRAMINI' as TypeOfWine,
  Viognier: 'VIOGNIER' as TypeOfWine,
  Vulcan: 'VULCAN' as TypeOfWine,
  ValtelinBlanc: 'VALTELIN_BLANC' as TypeOfWine,
  Barbera: 'BARBERA' as TypeOfWine,
  BullsBlood: 'BULLS_BLOOD' as TypeOfWine,
  Blauburger: 'BLAUBURGER' as TypeOfWine,
  CabernetFranc: 'CABERNET_FRANC' as TypeOfWine,
  CabernetSauvignon: 'CABERNET_SAUVIGNON' as TypeOfWine,
  Carmenere: 'CARMENERE' as TypeOfWine,
  Chianti: 'CHIANTI' as TypeOfWine,
  KissingGrape: 'KISSING_GRAPE' as TypeOfWine,
  BlackPavement: 'BLACK_PAVEMENT' as TypeOfWine,
  BlackGirl: 'BLACK_GIRL' as TypeOfWine,
  Gamay: 'GAMAY' as TypeOfWine,
  Grenache: 'GRENACHE' as TypeOfWine,
  Kadarka: 'KADARKA' as TypeOfWine,
  BlueFrankish: 'BLUE_FRANKISH' as TypeOfWine,
  Lambrusco: 'LAMBRUSCO' as TypeOfWine,
  Malbec: 'MALBEC' as TypeOfWine,
  Mavrodaphne: 'MAVRODAPHNE' as TypeOfWine,
  Mencia: 'MENCIA' as TypeOfWine,
  Merlot: 'MERLOT' as TypeOfWine,
  Montepulciano: 'MONTEPULCIANO' as TypeOfWine,
  Nebbiolo: 'NEBBIOLO' as TypeOfWine,
  NeroDavola: 'NERO_DAVOLA' as TypeOfWine,
  PetitVerdot: 'PETIT_VERDOT' as TypeOfWine,
  PinotNoir: 'PINOT_NOIR' as TypeOfWine,
  Pinotage: 'PINOTAGE' as TypeOfWine,
  Porto: 'PORTO' as TypeOfWine,
  Portuguese: 'PORTUGUESE' as TypeOfWine,
  Primitive: 'PRIMITIVE' as TypeOfWine,
  Refosco: 'REFOSCO' as TypeOfWine,
  RoseBlendingCuvee: 'ROSE_BLENDING_CUVEE' as TypeOfWine,
  Sangiovese: 'SANGIOVESE' as TypeOfWine,
  StLawrence: 'ST_LAWRENCE' as TypeOfWine,
  Syrah: 'SYRAH' as TypeOfWine,
  Tempranillo: 'TEMPRANILLO' as TypeOfWine,
  Turan: 'TURAN' as TypeOfWine,
  RedBlendCuvee: 'RED_BLEND_CUVEE' as TypeOfWine,
  Zweigelt: 'ZWEIGELT' as TypeOfWine,
  BlendCuvee: 'BLEND_CUVEE' as TypeOfWine,
  Chardonnay: 'CHARDONNAY' as TypeOfWine,
  Ezzerjo: 'EZERJO' as TypeOfWine,
  SpicedFromCserszeg: 'SPICED_FROM_CSERSZEG' as TypeOfWine,
  BudaiZold: 'BUDAI_ZOLD' as TypeOfWine,
  Szamorodni: 'SZAMORODNI' as TypeOfWine,
  Zengoe: 'ZENGOE' as TypeOfWine,
  Zenith: 'ZENITH' as TypeOfWine,
  Csabagyongye: 'CSABAGYONGYE' as TypeOfWine,
  CheninBlanc: 'CHENIN_BLANC' as TypeOfWine,
  Cirfandli: 'CIRFANDLI' as TypeOfWine,
  Zeta: 'ZETA' as TypeOfWine,
  Aszu: 'ASZU' as TypeOfWine,
  EssenceOfAszu: 'ESSENCE_OF_ASZU' as TypeOfWine,
  Other: 'OTHER' as TypeOfWine,
};
